/* eslint-disable eqeqeq */
import React from 'react';
import {
  string,
  bool,
  number,
  func,
  oneOfType,
} from 'prop-types';

import FormInputContainer from '../../../scaffolding/FormInputContainer/FormInputContainer';
import InputV2 from '../../../controls/InputV2/InputV2';

const InputWithLabelV2 = ({
  id,
  label,
  value,
  required,
  title = '',
  placeholder,
  errorMsg = null,
  type = 'text',
  maxLength,
  onChange,
  autoComplete = null,
  selectAllOnFocus,
  disabled,
}) => (
  <FormInputContainer id={`${id}_container`}>
    <label id={`${id}_label`} htmlFor={id}>
      {label}
    </label>

    <InputV2
      value={value}
      id={id}
      type={type}
      autoComplete={autoComplete}
      onChange={onChange}
      required={required}
      title={title}
      hasError={errorMsg?.length > 0}
      lengthMessage={`Limit of ${maxLength} characters reached`}
      hasMessage={value?.length == maxLength}
      errorMsg={errorMsg}
      placeholder={placeholder || title}
      maxLength={typeof maxLength === 'string' ? Number(maxLength) : maxLength}
      selectAllOnFocus={selectAllOnFocus}
      disabled={disabled}
    />
  </FormInputContainer>
);

InputWithLabelV2.propTypes = {
  id: string.isRequired,
  label: string.isRequired,
  value: string.isRequired,
  required: bool,
  title: string,
  placeholder: string,
  errorMsg: string,
  type: string,
  maxLength: oneOfType([number, string]).isRequired,
  onChange: func.isRequired,
  autoComplete: oneOfType([string, bool]),
  selectAllOnFocus: bool,
  disabled: bool,
};

InputWithLabelV2.defaultProps = {
  required: true,
  title: '',
  placeholder: '',
  errorMsg: null,
  type: 'text',
  autoComplete: null,
  selectAllOnFocus: false,
  disabled: false,
};

export default InputWithLabelV2;
